import { ApiError } from './ApiError';
import { type ProblemDetails } from '../../types/error.types';

export class NotFoundError extends ApiError {

    constructor(problem: ProblemDetails) {
        super(problem);
        this.name = "NotFoundError";
    }
}